import { Drawer } from 'antd'

import { drawerAndModalWidth } from '../../../../../util/guideline'
import { CreateRatingCompliance } from './CreateRatingComplianceRule'

interface CreateRatingComplianceDrawerProps {
  domain: string
  groupId: number
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const CreateRatingComplianceRuleDrawer = ({
  domain,
  groupId,
  isVisible,
  onClose,
  onSuccess,
}: CreateRatingComplianceDrawerProps) => (
  <Drawer
    title="Create Rating Compliance Rule"
    placement="right"
    open={isVisible}
    onClose={onClose}
    width={drawerAndModalWidth}
    destroyOnClose
  >
    <CreateRatingCompliance domain={domain} groupId={groupId} onSuccess={onSuccess} />
  </Drawer>
)
